// 一些网页

// 没有设置 x-frame-options 的网站
export const domainAllowed = [
  "u1s1.site",
  "ghost.io",
  "cubox.pro",
  "zhubai.love",
  "quail.ink",
  "yuque.com",
  "juejin.cn",
  "eleduck.com",
  "feishu.cn",
  "okjike.com",
  "inside.com.tw",
  "bilibili.com",
  "flowus.cn",
  "gcores.com",
  "sspai.com",
  "douban.com",
  "zhiy.cc",
  "hedwig.pub",
  "beehiiv.com",
  "lusun.com",
  "paragraph.xyz",
  "mirror.xyz",
  "gridea.dev",
  "typlog.io",
  "xlog.app",
  "xfeed.app",
  "xchar.app",
  "hoot.it",
  "crossbell.io",
  "indiehackers.com",
  "hellogithub.com",
  "appinn.com",
  "learnku.com",
  "owwly.com",
  "wikipedia.org",
  "clickup.com",

  // dev
  "caniuse.com",
  "vitejs.dev",
  "vueuse.org",
  "typescriptlang.org",
  "nuxt.com",
  "nuxt.com.cn",
  "rustwiki.org",
  "flutter.dev",
  "flutter.cn",
  "flutterchina.club",
  "guoshuyu.cn",
  "dart.cn",
  "dartcn.com",
  "dartpad.cn",
  "dartpad.dev",
  "nodejs.org",
  "bun.sh",
  "electronjs.org",
  "tauri.app",
  "reactnative.dev",
  "react.dev",
  "ionicframework.com",
  "svelte.dev",

  // blogs
  "ruanyifeng.com",
  "lutaonan.com",
  "mt.cd",
  "chi.miantiao.me",
  "cnworkshop.xyz",
  "matthewball.co",
  
  "latepost.com",
  "36kr.com",
  "bing.com",
  "mailchi.mp",
  "campaign-archive.com",
  "guokr.com",
  "sina.com.cn",
  "bento.me",
  "cn.nytimes.com",
  "typeform.com",
  "forms.office.com",
  "sway.office.com",
  "mem.ai",
  "val.town",
  "booking.com",
  "readhub.cn",
  "hackertalk.net",
  "craft.me",
  "i.ibb.co",
  "chainfeeds.xyz",
  "wsj.com",
  "speakerdeck.com",
  "baike.baidu.com",
  "bbs.vika.cn",
  "player.fireside.fm",
  "ithome.com",
  "suno.ai",
  "jsoncrack.com",
  "supertechfans.com",
  "kimi.moonshot.cn",
  "chatglm.cn",
  "hailuoai.com",
  "stepchat.cn",
  "tiangong.cn",
  "wanzhi.com",
  "163.com",
  "chinaz.com",
  "sohu.com",
  "csdn.net",
  "utgd.net",
  "psyche.co",

  // about search
  "thinkany.ai",
  "n.cn",
  "onionai.so",
  "felo.ai",
  "memfree.me",

  // about podcast
  "podcastogether.com",
  "xiaoyuzhoufm.com",
  "podquest.app",
  "pod.link",
  "embeds.audioboom.com",
  "xiaohuolufm.com",
]

export const mastodonDomains = [
  "universeodon.com",
  "mastodon.ie",
  "mastodon.world",
  "mastodon.social",
  "mstdn.social",
  "mastodon.cloud",
  "w3c.social",
  "mastodon.uno",
  "mastodon.online",
  "mastodon.au",
  "mastodonapp.uk",
  "mstdn.jp",
  "mastodon.nl",
  "aus.social",
  "mastodon.art",
  "alive.bar",
  "masto.ai",
  "webtoo.ls",
  "mas.to",
  "fosstodon.org",
  "mozilla.social",
  "techhub.social",
  "romancelandia.club",
  "m.cmx.im",
  "douchi.space",
  "hyan.ink",
  "mast.lat",
  "openbiblio.social",
  "androiddev.social",
  "iosdev.space",
  "tech.lgbt",
  "c.im",
  "chaos.social",
  "mathstodon.xyz",
]
